module.exports = __webpack_public_path__ + "static/media/aacc.f486f9a6.png";